<div class="p-6 flex flex-col gap-4">
  <app-table
    [config]="calculationQueryResultTable"
    [data]="calculationQueryResultData"
    [(selectedElements)]="selectedElements"
    (selectedElementsChange)="elementSelected($event)"
  ></app-table>

  @if (selectedElements && selectedElements.length === 1) {
    <app-table
      [config]="detailTable"
      [data]="detailTableData"
    ></app-table>
  }
</div>
